import axios from "axios";
import toast from "react-hot-toast";

let interceptorsInstalled = false;

const isAuthEndpoint = (url = "") =>
  url.includes("/auth/signin") ||
  url.includes("/auth/signup") ||
  url.includes("/auth/forgot-password") ||
  url.includes("/auth/verify-otp");

export const installAxiosInterceptors = () => {
  if (interceptorsInstalled) return;
  interceptorsInstalled = true;

  axios.interceptors.response.use(
    (response) => response,
    async (error) => {
      const status = error?.response?.status;
      const url = error?.config?.url || "";

      // Blob downloads (CSV/Excel/PDF exports use responseType: "blob") return
      // their error body as a Blob, so `error.response.data.message` is always
      // undefined. Read the blob back into JSON so the real backend message
      // surfaces in the toast and is available to component-level catches.
      if (error?.response?.data instanceof Blob) {
        try {
          const text = await error.response.data.text();
          if (text) error.response.data = JSON.parse(text);
        } catch (_) {
          // Non-JSON blob (or empty) — leave the original data in place.
        }
      }

      const message =
        error?.response?.data?.message ||
        error?.message ||
        "Something went wrong";

      if (status === 401 && !isAuthEndpoint(url)) {
        toast.error("Session expired. Please log in again.");
        try {
          localStorage.clear();
          sessionStorage.clear();
        } catch (_) {}
        setTimeout(() => {
          window.location.href = "/signin";
        }, 600);
      } else if (status === 403) {
        const userRole = localStorage.getItem("userRole");
        const isCrmRoute = url.includes("/boards");
        if (userRole === "Consultant" && isCrmRoute) {
          localStorage.setItem("hasSalesPersonRole", "false");
          localStorage.setItem("assignedBoardIds", "[]");
          toast.error("Your CRM access has been removed. Contact the admin.");
          setTimeout(() => {
            window.location.href = "/consultant/dashboard";
          }, 600);
        } else {
          toast.error(message || "You don't have access to this resource.");
        }
      } else if (status >= 400 && status < 500) {
        toast.error(message);
      } else if (status >= 500) {
        toast.error(message || "Server error. Please try again later.");
      } else if (!error?.response) {
        toast.error("Network error. Please check your connection.");
      }

      return Promise.reject(error);
    }
  );
};

export default installAxiosInterceptors;
